import { convertToNewColors, } from '@pomofocus/core';
import * as cons from '../constants';
import * as sounds from '../sounds';
let db;
const request = indexedDB.open('pomofocus', 23);
request.onupgradeneeded = (e) => {
    /*
          config = {
              darkModeEnabled: true,
              stageSeconds: [1500, 300, 900],
          }
      */
    db = e.target.result;
    try {
        db.deleteObjectStore('config');
    }
    catch (error) { }
    try {
        db.deleteObjectStore('timerState');
    }
    catch (error) { }
    try {
        db.deleteObjectStore('activity');
    }
    catch (error) { }
    // try {
    //   db.deleteObjectStore('template');
    // } catch (error) {}
    // try {
    //   db.deleteObjectStore('report');
    // } catch (error) {
    //
    // }
    db.createObjectStore('config', { keyPath: 'key' });
    db.createObjectStore('timerState', { keyPath: 'key' });
    db.createObjectStore('activity', { keyPath: 'id' });
    // db.createObjectStore('template', { keyPath: 'id' });
    // db.createObjectStore('report', { keyPath: 'dateObj' });
};
request.onsuccess = (e) => {
    db = e.target.result;
};
export const saveConfig = ({ darkModeEnabled, autoStartEnabled, autoStartPomodoroEnabled, autoSwitchTasks, autoCheckTasks, soundVolume, stageSeconds, longBreakInterval, notificationType, notificationMinutes, tickingSoundType, tickingVolume, alarmSoundType, alarmRepeatTimes, hourFormat, weekStart, colorThemes, }) => {
    try {
        const tx = db.transaction('config', 'readwrite');
        const config = tx.objectStore('config');
        // config.clear();
        config.put({
            key: 'darkModeEnabled',
            value: darkModeEnabled ? 1 : 0,
        });
        config.put({
            key: 'autoStartEnabled',
            value: autoStartEnabled ? 1 : 0,
        });
        config.put({
            key: 'autoStartPomodoroEnabled',
            value: autoStartPomodoroEnabled ? 1 : 0,
        });
        config.put({
            key: 'autoSwitchTasks',
            value: autoSwitchTasks ? 1 : 0,
        });
        config.put({
            key: 'autoCheckTasks',
            value: autoCheckTasks ? 1 : 0,
        });
        config.put({ key: 'stageSeconds', value: stageSeconds });
        config.put({ key: 'soundVolume', value: soundVolume });
        config.put({
            key: 'longBreakInterval',
            value: longBreakInterval,
        });
        config.put({ key: 'notificationType', value: notificationType });
        config.put({
            key: 'notificationMinutes',
            value: notificationMinutes,
        });
        config.put({ key: 'tickingSoundType', value: tickingSoundType });
        config.put({ key: 'tickingVolume', value: tickingVolume });
        config.put({ key: 'alarmSoundType', value: alarmSoundType });
        config.put({ key: 'alarmRepeatTimes', value: alarmRepeatTimes });
        config.put({ key: 'hourFormat', value: hourFormat });
        config.put({ key: 'weekStart', value: weekStart });
        config.put({ key: 'colorThemes', value: colorThemes });
    }
    catch (err) { }
};
// Config
async function getValueFromDB(storeName, keyName) {
    try {
        const tx = db.transaction(storeName, 'readwrite');
        const store = tx.objectStore(storeName);
        const req = await store.get(keyName);
        return new Promise((resolve) => {
            req.onsuccess = () => {
                if (req.result) {
                    resolve(req.result.value);
                }
                else {
                    resolve(null);
                }
            };
        });
    }
    catch (error) { }
}
export async function getConfigObj() {
    const darkModeEnabled = await getValueFromDB('config', 'darkModeEnabled');
    const autoStartEnabled = await getValueFromDB('config', 'autoStartEnabled');
    const autoStartPomodoroEnabled = await getValueFromDB('config', 'autoStartPomodoroEnabled');
    const autoSwitchTasks = await getValueFromDB('config', 'autoSwitchTasks');
    const autoCheckTasks = await getValueFromDB('config', 'autoCheckTasks');
    const soundVolume = await getValueFromDB('config', 'soundVolume');
    const stageSeconds = await getValueFromDB('config', 'stageSeconds');
    const longBreakInterval = await getValueFromDB('config', 'longBreakInterval');
    const notificationType = await getValueFromDB('config', 'notificationType');
    const tickingSoundType = await getValueFromDB('config', 'tickingSoundType');
    const alarmSoundType = await getValueFromDB('config', 'alarmSoundType');
    const alarmRepeatTimes = await getValueFromDB('config', 'alarmRepeatTimes');
    const tickingVolume = await getValueFromDB('config', 'tickingVolume');
    const notificationMinutes = await getValueFromDB('config', 'notificationMinutes');
    const hourFormat = await getValueFromDB('config', 'hourFormat');
    const weekStart = await getValueFromDB('config', 'weekStart');
    const colorThemes = await getValueFromDB('config', 'colorThemes');
    const configNewColors = convertToNewColors(colorThemes);
    const configObj = {
        darkModeEnabled: darkModeEnabled === 1,
        autoStartEnabled: autoStartEnabled === 1,
        autoStartPomodoroEnabled: autoStartPomodoroEnabled === 1,
        autoSwitchTasks: autoSwitchTasks === 0 ? false : true,
        autoCheckTasks: autoCheckTasks === 1,
        stageSeconds: stageSeconds || [1500, 300, 900],
        soundVolume: soundVolume || 50,
        tickingVolume: tickingVolume || 50,
        longBreakInterval: longBreakInterval || 4,
        notificationType: notificationType || cons.NT_LAST,
        tickingSoundType: tickingSoundType || sounds.TICKING_NONE,
        notificationMinutes: notificationMinutes >= 0 ? notificationMinutes : 5,
        alarmSoundType: alarmSoundType || sounds.ALARM_KITCHEN,
        alarmRepeatTimes: alarmRepeatTimes || 1,
        hourFormat: hourFormat || cons.HOUR_FORMAT_24,
        weekStart: weekStart || cons.WEEK_START_MONDAY,
        colorThemes: configNewColors,
        configLoaded: true,
        webpushSubs: [],
        webhookUri: '',
        configModalVisible: false,
    };
    return configObj;
}
/**
 * Timer State
 */
export const saveTimerStateLocalDB = ({ selectedActivity, dateDigit, pomodoroCnt, }) => {
    try {
        const tx = db.transaction('timerState', 'readwrite');
        const config = tx.objectStore('timerState');
        if (dateDigit) {
            config.put({
                key: 'lastUpdate',
                value: dateDigit,
            });
        }
        if (selectedActivity) {
            config.put({
                key: 'selectedActivity',
                value: selectedActivity,
            });
        }
        if (pomodoroCnt) {
            config.put({
                key: 'pomodoroCnt',
                value: pomodoroCnt,
            });
        }
    }
    catch (err) { }
};
export async function getTimerStateLocalDB(dateDigit) {
    const lastUpdate = await getValueFromDB('timerState', 'lastUpdate');
    const pomodoroCnt = await getValueFromDB('timerState', 'pomodoroCnt');
    const selectedActivity = await getValueFromDB('timerState', 'selectedActivity');
    const timerState = {
        selectedActivity: selectedActivity || null,
        pomodoroCnt: dateDigit === lastUpdate ? pomodoroCnt : 0,
    };
    return timerState;
}
export const changePomodoroCntLocalDB = (pomodoroCnt, dateDigit) => {
    try {
        const tx = db.transaction('timerState', 'readwrite');
        const config = tx.objectStore('timerState');
        config.put({
            key: 'lastUpdate',
            value: dateDigit,
        });
        config.put({
            key: 'pomodoroCnt',
            value: pomodoroCnt,
        });
    }
    catch (err) { }
};
export const setActivity = ({ id, title, estPomodoro, actPomodoro, note, projectName, order, done, }) => {
    try {
        const tx = db.transaction('activity', 'readwrite');
        const activity = tx.objectStore('activity');
        activity.put({
            id,
            title,
            estPomodoro,
            actPomodoro,
            done: done || 0,
            note,
            projectName,
            order,
        });
    }
    catch (error) { }
};
export const incrementActPomodoroLocalDB = async ({ id, estPomodoroUnit, }) => {
    try {
        const tx = db.transaction('activity', 'readwrite');
        const activity = tx.objectStore('activity');
        const activityReq = await activity.get(id);
        activityReq.onsuccess = () => {
            if (!activityReq.result)
                return;
            const { title, actPomodoro, estPomodoro, done, projectName, order, } = activityReq.result;
            activity.put({
                id,
                title,
                actPomodoro: actPomodoro + estPomodoroUnit,
                estPomodoro,
                done,
                projectName,
                order,
            });
        };
    }
    catch (error) { }
};
export const deleteOneActivity = ({ id }) => {
    try {
        const tx = db.transaction('activity', 'readwrite');
        const activity = tx.objectStore('activity');
        activity.delete(id);
    }
    catch (error) { }
};
export const getActivities = async () => {
    try {
        const tx = db.transaction('activity', 'readwrite');
        const activity = tx.objectStore('activity');
        const activityReq = await activity.getAll();
        return new Promise((resolve) => {
            activityReq.onsuccess = () => {
                if (activityReq.result) {
                    resolve(activityReq.result);
                }
                else {
                    resolve(null);
                }
            };
        });
    }
    catch (error) { }
};
export const clearFinishedTasksDB = async () => {
    try {
        const tx = db.transaction('activity', 'readwrite');
        const activity = tx.objectStore('activity');
        const activityReq = await activity.getAll();
        activityReq.onsuccess = () => {
            activityReq.result.forEach((a) => {
                const { id, 
                // title,
                // estPomodoro,
                done,
                // note,
                // projectName,
                // order,
                 } = a;
                if (done === 1) {
                    activity.delete(id);
                }
                // else {
                //   activity.put({
                //     id,
                //     title,
                //     actPomodoro: 0,
                //     estPomodoro,
                //     done,
                //     note,
                //     projectName,
                //     order,
                //   });
                // }
            });
        };
    }
    catch (error) { }
};
export const clearAllTasksDB = async () => {
    try {
        const tx = db.transaction('activity', 'readwrite');
        const activity = tx.objectStore('activity');
        const activityReq = await activity.getAll();
        activityReq.onsuccess = () => {
            activityReq.result.forEach((a) => {
                activity.delete(a.id);
            });
        };
    }
    catch (error) { }
};
export const clearActPomodorosDB = async () => {
    try {
        const tx = db.transaction('activity', 'readwrite');
        const activity = tx.objectStore('activity');
        const activityReq = await activity.getAll();
        activityReq.onsuccess = () => {
            activityReq.result.forEach((a) => {
                const { id, title, estPomodoro, done, note, projectName, order, } = a;
                activity.put({
                    id,
                    title,
                    actPomodoro: 0,
                    estPomodoro,
                    done,
                    note,
                    projectName,
                    order,
                });
            });
        };
    }
    catch (error) { }
};
export const checkTaskInDB = async (activityId, newDone) => {
    try {
        const tx = db.transaction('activity', 'readwrite');
        const activity = tx.objectStore('activity');
        const activityReq = await activity.get(activityId);
        activityReq.onsuccess = () => {
            const { id, title, actPomodoro, estPomodoro, note, projectName, order, } = activityReq.result;
            activity.put({
                id,
                title,
                actPomodoro,
                estPomodoro,
                done: newDone,
                note,
                projectName,
                order,
            });
        };
    }
    catch (error) { }
};
// Template
// export const saveTemplateLocalDB = todos => {
//   try {
//     const tx = db.transaction('template', 'readwrite');
//     const template = tx.objectStore('template');
//     template.clear();
//     todos.forEach(todo => {
//       template.put({
//         id: todo.id,
//         title: todo.title,
//         estPomodoro: todo.estPomodoro,
//         note: todo.note,
//       });
//     });
//   } catch (error) {}
// };
// export const getTemplateLocalDB = async () => {
//   try {
//     const tx = db.transaction('template', 'readwrite');
//     const template = tx.objectStore('template');
//     const templateReq = await template.getAll();
//     return new Promise(resolve => {
//       templateReq.onsuccess = () => {
//         if (templateReq.result) {
//           resolve(templateReq.result);
//         } else {
//           resolve(null);
//         }
//       };
//     });
//   } catch (error) {}
// };
// Report
// export const saveDailyWorkHours = dailyWorkHours => {
//   const tx = db.transaction('report', 'readwrite');
//   const report = tx.objectStore('report');
//   report.clear();
//   dailyWorkHours.forEach(data => {
//     const { dateStr, dateObj, minutes, projectName } = data;
//     report.put({ dateStr, dateObj, minutes, projectName });
//   });
// };
// export const getDailyWorkHours = async () => {
//   const tx = db.transaction('report', 'readwrite');
//   const report = tx.objectStore('report');
//   const reportReq = await report.getAll();
//   return new Promise(resolve => {
//     reportReq.onsuccess = () => {
//       if (reportReq.result) {
//         resolve(reportReq.result);
//       } else {
//         resolve(null);
//       }
//     };
//   });
// };
